import {
  AppThemeProvider,
  KeyEventHandler,
  StartApi
} from "./context";
import { AppRoutes } from "./routes";
import "./prototypes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import "dayjs/locale/pt-br";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <AppThemeProvider>
        <KeyEventHandler>
          <StartApi>
            <AppRoutes />
          </StartApi>
        </KeyEventHandler>
      </AppThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
